<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="modalloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2" v-if="!modalloading">
        <h3 style="word-break: break-word">{{ getTitle }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click.native.stop="closeModal()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-row>
          <v-col cols="12" md="12">
             <v-row style="border-bottom: 1px solid grey">
                <v-col cols="12" md="12">
                  <v-row>
                    <template v-if="showSMSInfo">
                      <v-col cols="12">
                          <span class="info-sms-msg">{{ showSMSInfo }}</span>
                      </v-col>
                      <v-divider></v-divider>
                    </template>
                    <v-col class="pb-0" cols="12" sm="3" md="3">
                      <el-checkbox
                        style="margin-top: 3px"
                        label="SMS žinute"
                        v-model="newSmsEnabled"
                      >
                      </el-checkbox>
                    </v-col>
                    <v-col class="pb-0" cols="12" sm="9"  md="9">
                      <v-row no-gutters>
                        <v-col cols="3">
                          <!-- <el-text-field
                            :required="newSmsEnabled"
                            v-model="newPhonePrepend"
                            prependField
                            :validateKey="getKeyPhoneNumber"
                          /> -->
                          <el-select
                            :required="newSmsEnabled"
                            v-model="newPhonePrependISO"
                            prependField
                            enableSearch
                            searchKey="display_name"
                            prependValueKey="display_name"
                            itemvalue="iso"
                            :items="getCountries"
                            :validateKey="getKeyPhoneNumber"
                          />
                        </v-col>
                        <v-col cols="9">
                          <el-text-field
                            :required="newSmsEnabled"
                            style="border-radius: 0px 4px 4px 0px;"
                            digits="8"
                            phoneNumber2
                            label="Telefono numeris"
                            v-model="newPhone"
                            :validateKey="getKeyPhoneNumber"
                            :key="getKeyPhoneNumber"
                          />
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col class="py-0" cols="12" sm="3" md="3">
                    <el-checkbox
                      style="margin-top: 3px"
                      label="El. paštu"
                      tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Naujas įgaliojimas. El paštu"
                      :tooltipIndexKey= item.amn_id
                      v-model="newEmailEnabled"
                    >
                    </el-checkbox>
                  </v-col>
                    <v-col class="py-0" cols="12" sm="9" md="9">
                      <el-text-field
                        :required="newEmailEnabled"
                        email
                        label="El. paštas"
                        v-model="newEmail"
                        :validateKey="getKeyEmailAddress"
                        :key="getKeyEmailAddress"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          title="Pridėti"
          :loading="loading"
          @click.native.stop="addContact()"
          color="primary"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import countries from 'countries-phone-masks'

const updatedCountries = countries.map(obj => ({
  ...obj,
  display_name: `${obj.code} ${obj.name}`,
}));

export default {
  name: 'ModalContactForm',
  props: {
    item: Object,
    value: Boolean,
    loading: Boolean,
  },
  $_veeValidate: {
    validator: 'new',
  },

  data() {
    return {
      oldPhone: null,
      oldPhonePrepend: null,
      oldEmail: null,
      oldEmailEnabled: null,
      oldSmsEnabled: null,
      newPhone: null,
      newPhonePrepend: null,
      newPhonePrependISO: null,
      newEmail: null,
      newEmailEnabled: null,
      newSmsEnabled: null,
    }
  },
  computed: {
    showSMSInfo(){
      // if(this.item.phone_number_prepend != '' && (this.item.phone_number_prepend != '+370' && this.item.phone_number_prepend != '370') && this.item.phone_number_prepend != null) {
        return this.$t('Informuojame, kad trumpieji pranešimai (SMS) siunčiami tik Lietuvoje veikiančių mobiliojo ryšio operatorių registruotiems telefono numeriams.')
      // } else {
        // return ''
      // }
    },
    getCountries() {
        return updatedCountries
    },
    getKeyPhoneNumber() {
        return `phone-number-${this.index}`
    },
    getKeyEmailAddress() {
        return `email-address-${this.index}`
    },
    phoneNumberReq() {
        return this.item.sms_enabled
    },
    emailAddressReq() {
        return this.item.email_enabled
    },
    getTitle() {
      return this.item.fullname
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  watch: {
    showModal: {
      immediate: true,
      handler(val, oldVal) {
        if (val == true) {
          this.oldEmail = this.item.email_address
          this.oldPhone = this.item.phone_number
          this.oldPhonePrepend = this.item.phone_number_prepend
          this.oldEmailEnabled = this.item.email_enabled
          this.oldSmsEnabled = this.item.sms_enabled
          this.newEmail = this.item.email_address
          this.newPhone = this.item.phone_number
          this.newPhonePrepend = this.item.phone_number_prepend
          this.newPhonePrependISO = this.item.phone_number_prepend_iso || 'LT'
          this.newEmailEnabled = this.item.email_enabled
          this.newSmsEnabled = this.item.sms_enabled
        }
      }
    },
  },

  created() {
    this.modalloading = false
  },
  methods: {
    getCountryCode(iso) {
      return this.getCountries.find(item => {
       return item.iso === iso
      }).code
    },
    addContact() {
       this.$validator.validateAll().then((res) => {
        if (res) {
          this.item.email_address = this.newEmail
          this.item.phone_number = this.newPhone
          this.item.phone_number_prepend = this.getCountryCode(this.newPhonePrependISO)
          this.item.phone_number_prepend_iso = this.newPhonePrependISO
          this.item.email_enabled = this.newEmailEnabled
          this.item.sms_enabled = this.newSmsEnabled
          this.showModal = false
          this.$emit('reloadContact')
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.item.email_address = this.oldEmail
      this.item.phone_number = this.oldPhone
      this.item.phone_number_prepend = this.oldPhonePrepend
      this.item.email_enabled = this.oldEmailEnabled
      this.item.sms_enabled = this.oldSmsEnabled
      this.showModal = false
    },

    cancel() {
      this.closeModal()
    },

    inputChange() {
      this.$emit('inputChange')
    }
  },
}
</script>
<style lang="scss" scoped></style>
